"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const _4d_mapper_1 = require("4d-mapper");
const veflux_1 = require("vasat/dist/src/veflux");
const tree_events_1 = require("./tree-events");
const file_data_service_1 = require("../file-data.service");
class FilePickerComponent {
    constructor(fileManager, builder) {
        this.fileManager = fileManager;
        this.builder = builder;
        this.mode = 'files';
        this.onSelectedFiles = new core_1.EventEmitter();
        this.onSelectedFolders = new core_1.EventEmitter();
        this.onCancel = new core_1.EventEmitter();
        this.displayedFilesStore = new veflux_1.ArrayStore(file_data_service_1.FileEvent);
        this.selectedFilesStore = new veflux_1.ArrayStore(file_data_service_1.FileEvent, [], this.displayedFilesStore);
        this.selectedFolderStore = new veflux_1.Store(tree_events_1.TreeEvent);
        this.canPick = false;
        this.files = [];
        this.folderRoot = new veflux_1.ArrayStore(tree_events_1.TreeEvent);
        this._subs = [];
    }
    ngOnInit() {
        this.fileManager.onTeamReady().subscribe(_ => {
            if (this.startInFolder) {
                this.folderRoot.values = [this.builder.fromFolder(this.startInFolder)];
            }
            else {
                this.folderRoot.values = [this.builder.fromAccount(this.fileManager.team.value)];
            }
        });
        this._subs.push(this.selectedFilesStore.state.subscribe(f => {
            this.files = f;
            this.checkPick();
        }));
        this._subs.push(this.selectedFolderStore.state.subscribe(s => this.folder = s.ref instanceof _4d_mapper_1.Folder ? s.ref : null));
    }
    ngOnDestroy() {
        this._subs.forEach(s => s.unsubscribe());
    }
    pick() {
        if (this.mode == 'files') {
            this.onSelectedFiles.emit(this.selectedFilesStore.values);
        }
        else {
            this.onSelectedFolders.emit(this.selectedFolderStore.value.ref);
        }
    }
    cnx() {
        this.onCancel.emit(true);
    }
    checkPick() {
        if (this.mode == 'files') {
            this.canPick = !!this.files.length;
        }
        else {
            this.canPick = !!this.folder;
        }
    }
}
exports.FilePickerComponent = FilePickerComponent;
